import { useAuth } from '../../../use';
import { odata } from '../../conf';
import Actions from '../../odata/actions';

const auth = useAuth();
const actions = new Actions('keywordHistory', 'keywordHistories');

const customActions = {
  async LOAD_keywordHistories({ rootGetters, commit }) {
    const token = await auth.getAccessToken();
    const data = await odata.o(rootGetters, token)
      .get('keywordHistories')
      .query({
        $orderby: 'created desc',
        $expand: 'KeywordHistoryResults',
      });
    commit('SET_keywordHistories', data);
    return data;
  },
};

export default { ...actions, ...customActions };
